import { render, staticRenderFns } from "./Anvil.vue?vue&type=template&id=ee970784&scoped=true&"
import script from "./Anvil.vue?vue&type=script&lang=js&"
export * from "./Anvil.vue?vue&type=script&lang=js&"
import style0 from "./Anvil.vue?vue&type=style&index=0&id=ee970784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee970784",
  null
  
)

export default component.exports